<template lang="html">
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 grid-margin">
        <div class="row">
          <div class="col-sm-12 pr-0">
            <div class="d-lg-flex">
              <div class="col-md-4">
                <h3 class="text-light font-weight-bold mb-0 mr-5">{{strategy.title}} Strategy  <span class="mean-class"><img style="width:28px; cursor:pointer; margin-bottom: 7px" src="/static/images/ask-question.png" @click="description_show()"></span></h3>
              </div>
              <div class="col-md-8 button-group">
                <button v-if="editingSubscription && $parent.plan_status>2 && subscriptionPaused==false && current_buy_flag == true" type="button" name="button" class='btn btn-secondary '  v-on:click="make_trading()">{{"Connect"}}</button>
                <button v-if="editingSubscription && $parent.plan_status>2 && subscriptionPaused==false && current_sell_flag == true" type="button" name="button" class='btn btn-secondary ' v-on:click="make_trading()">{{"Close trade"}}</button>
                <button v-if="editingSubscription && subscriptionPaused && $parent.plan_status>3" type="button" name="button" class='btn btn-secondary '  v-on:click="resumeSubscriptionModalShow()">{{lang=="ru"?"Запустить":"Resume"}}</button>
                <button v-if="editingSubscription && trading.enabled ==false && trading.percent_usdt == false && $parent.plan_status>1 && is_only_alert == true" type="button" name="button" class='btn btn-secondary '  v-on:click="only_alert()">{{lang=="ru"?"Включить уведомления":"Switch on alerts"}}</button>
                <button v-if="$parent.user_id && editingSubscription" type="button" name="button" class='btn btn-secondary backtest-button' v-on:click="scrollToBottom()">{{lang=="ru"?"Значения":"Inputs"}}</button>
                <button v-if="$parent.user_id && editingSubscription" type="button" name="button" class='btn btn-secondary ' v-on:click="openPropertiesModal()">{{lang=="ru"?"Свойства":"Properties"}}</button>
                <button v-if='$parent.user_id && $parent.plan_status>1 && editingSubscription' type="button" name="button" class='btn btn-primary ' v-on:click="confirmSubscription()" v-html="lang=='ru'?'Сохранить':'Save'"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body pt-3">
            <div id="chart" style="height: 100%; width: 100%;"></div>
          </div>
        </div>
      </div>
      <div v-if="isActive && $parent.plan_status>1" class="water-mark">
        <h2 v-bind:class="{'watermaker':isAnimation,'water-letter':isWord}">{{watermaker_1}}</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6 col-12">
        <div class="card">
          <div class="card-body" >
            <h4 class="card-title">{{isOrderlist?'':(lang=="ru"?"Динамика баланса":"Balance movement")}} 
              <span v-if='backtestingNow && isOrderlist==0 && $parent.plan_status>1' class='text-secondary'>Loading...</span> 
              <button v-if="existOrder && isBalanceMovement == 0" type="button" name="button" class='btn btn-primary' @click="changeOrderList('ba')" style="float:right; margin-left: 10px;">Balance movement</button>
              <button v-if="existOrder && isOrderlistMonthly == 0" type="button" name="button" class='btn btn-primary' @click="changeOrderList('mo')" style="float:right; margin-left: 10px;">Month backtest</button>
              <button v-if="existOrder && isOrderlist == 0" type="button" name="button" class='btn btn-primary' @click="changeOrderList('li')" style="float:right">List of trades</button>
            </h4>
            <div style="height: 400px; text-align:center; margin-top:20px; padding-bottom: 10px">
              <apexchart type="area" v-if="isBalanceMovement" height="425" ref="chart" :options="chartOptions" :series="orderMovementData()"></apexchart>
              <div class="table-container" v-if="isOrderlist" style="height: 370px;overflow-y: scroll; margin-top:50px; width:100%">
                <table class="responsive"  style="width: 100%; border: 1px solid #313452">
                  <tbody>
                    <tr style='border-bottom: 1px solid #313452' v-for="order in orders">
                      <td class="td-element">
                        <p>{{strategy.hasShort?'Sell':'Buy'}}</p>
                        <p>Close</p>
                      </td>
                      <td class="td-element">
                        <p>{{format_datetime(order.entry_timestamp).substr(0, 17)}}</p>
                        <p>{{format_datetime(order.exit_timestamp).substr(0, 17)}}</p>
                      </td>
                      <td class="td-element">
                        {{order.profit.toFixed(2)}}
                      </td>
                      <td class="td-element">
                        <p>
                          {{order.entry_price}}
                        </p>
                        <p>
                          {{order.exit_price}}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="table-container" v-if="isOrderlistMonthly" style="height: 370px;overflow-y: scroll; margin-top:50px; width:100%">
                <table class="responsive"  style="width: 100%; border: 1px solid #313452">
                  <tbody>
                    <tr style="border-bottom: 1px solid #313452" v-for="order in MonthlyOrders">
                      <td class="td-element">
                        <p>{{order.date}}</p>
                      </td>
                      <td class="td-element">
                        <p>{{order.data.reduce((a, b) => a + b, 0).toFixed(3)}}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-xl-3 grid-margin-1 stretch-card">
        <div class="card">
          <div class="card-body">
            <b-tabs v-model='openInputTab' justified content-class="preference-tab">
              <b-tab :title="inputs_text">
                <div class="form-group row">
                  <label class="col-sm-6">{{lang=="ru"?"Актив":"Asset"}}</label>
                  <div class="col-sm-6">
                    <b-dd :text="selectedPair.split(':')[1]">
                      <b-dropdown-item :disabled="$parent.plan_status<3" v-for="pair in supportedPairs" :key='pair' v-on:click="setPair(pair)">{{pair.split(':')[1]}}</b-dropdown-item>
                    </b-dd>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-6">{{lang=="ru"?"Таймфрейм":"Timeframe"}}</label>
                  <div class="col-sm-6">
                    <b-dd :text="formatTimeframe(selectedTimeframe)">
                      <b-dropdown-item :disabled="$parent.plan_status<3" v-for="tf in supportedTimeframes" :key='tf' v-on:click="setTimeframe(tf)">{{formatTimeframe(tf)}}</b-dropdown-item>
                    </b-dd>
                  </div>
                </div>
                <div class="form-group row" v-for='input in strategy.inputs' :key='input.id'>
                  <label :for="input.id" class="col-sm-6 col-form-label">{{input.title}}</label>
                  <div class="col-sm-6">
                    <input type="number" :disabled="$parent.plan_status<3" class="form-control" :id="input.id" placeholder="0" v-model='input.defval' v-on:blur="runBacktest()">
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">{{lang=="ru"?"Результаты":"Performance"}} <span v-if='long_orders[0]' class='text-secondary'>{{lang=="ru"?"с ":"Since "}} {{new Date(long_orders[0].entry_timestamp * 1000).toDateString().substring(4)}}</span></h4>
            <table class="table ">
              <thead>
                <tr>
                  <th></th>
                  <th v-if="strategy.hasShort">{{lang=="ru"?"короткий":"Short"}}</th>
                  <th v-else>Long</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><b>{{lang=="ru"?"Общая прибыль":"Total Profit"}}</b></td>
                  <td v-if="strategy.hasShort">{{shortProfit.toFixed(4)}}%</td>
                  <td v-else>{{longProfit.toFixed(4)}}%</td>
                </tr>
                <tr>
                  <td><b>{{lang=="ru"?"% прибыльных":"Pctg. profitable"}}</b></td>
                  <td v-if="strategy.hasShort">{{pctProfitable(short_orders).toFixed(2)}}%</td>
                  <td v-else>{{pctProfitables.toFixed(2)}}%</td>
                </tr>
                <tr>
                  <td><b>{{lang=="ru"?"Долгосрочная прибыль актива":"Buy&Hold return"}}</b></td>
                  <td>{{(bnhReturn*100).toFixed(2)}}%</td>
                </tr>
                <tr>
                  <td><b>{{lang=="ru"?"Сред. по сделке":"Avg. Trade"}}</b></td>
                  <td v-if="strategy.hasShort">{{avgTrade(0, short_orders).toFixed(2)}}%</td>
                  <td v-else>{{avgTrade(0, query_orders).toFixed(2)}}%</td>

                </tr>
                <tr>
                  <td><b>{{lang=="ru"?"Сред. прибыль по сделке":"Avg. Winning Trade"}}</b></td>
                  <td v-if="strategy.hasShort">{{avgTrade(1, short_orders).toFixed(2)}}%</td>
                  <td v-else>{{avgTrade(1, query_orders).toFixed(2)}}%</td>

                </tr>
                <tr>
                  <td><b>{{lang=="ru"?"Сред. убыток по сделке":"Avg. Loosing Trade"}}</b></td>
                  <td v-if="strategy.hasShort">{{avgTrade(-1, short_orders).toFixed(2)}}%</td>
                  <td v-else>{{avgTrade(-1, query_orders).toFixed(2)}}%</td>

                </tr>
                <tr>
                  <td><b>{{lang=="ru"?"Сред. баров в сделке":"Avg. Bars in trade"}}</b></td>
                  <td v-if="strategy.hasShort">{{ avgBarInTrade(0, short_orders) }}</td>
                  <td v-else>{{ avgBarInTrade(0, query_orders) }}</td>

                </tr>
                <tr>
                  <td><b>{{lang=="ru"?"Сред. баров в прибыльной позиции":"Avg. Bars in winning trade"}}</b></td>
                  <td v-if="strategy.hasShort">{{ avgBarInTrade(1, short_orders) }}</td>
                  <td v-else>{{ avgBarInTrade(1, query_orders) }}</td>

                </tr>
                <tr>
                  <td><b>{{lang=="ru"?"Сред. баров в убыточной позиции":"Avg. Bars in loosing trade"}}</b></td>
                  <td v-if="strategy.hasShort">{{ avgBarInTrade(-1, short_orders) }}</td>
                  <td v-else>{{ avgBarInTrade(-1, query_orders) }}</td>

                </tr>
                <tr>
                  <td><b>{{lang=="ru"?"Всего ордеров":"Total Orders"}}</b></td>
                  <td v-if="strategy.hasShort">{{short_orders.length}}</td>
                  <td v-else>{{query_orders.length}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card" style="margin-top: 10px">
          <div class="card-body" style="padding: 1.3rem">
            <div class="form-check form-check-flat form-check-primary">
                <label class="form-check-label">
                    <input type="checkbox" class="form-check-input"  id='trading_fee' v-model='trading_fee' @change="calculate_fee()">
                      {{lang=="ru"?"Расчет с торговыми комиссия ми Binance":"Calculate with Binance trading fees"}}
                    <i class="input-helper"></i>
                </label>
              </div>
          </div>
              <!-- <button v-if='this.$parent.binance_keys ==false' type="button" class='btn btn-primary pull-right' name="button">{{lang=="ru"?"Save":"Save"}}</button> -->
        </div>
      </div>
    </div>
  <!-- properties modal -->
  <b-modal v-model="propertiesModal" content-class="property-modal">
    <!-- <template v-slot:modal-title>
     {{lang=="ru"?"Свойства":"Properties"}}
    </template> -->
    <div class="header-title">
      <h3>Properties:</h3>
      <p>please choose your type of trading</p>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="subscription_title" class="col-sm-6">{{lang=="ru"?"Название":"Title"}}</label>
          <input type="text" class="form-control" :class='subscriptionTitle.length == 0 ? "border border-danger" : ""' id="subscription_title" v-model='subscriptionTitle'>
        </div>
      </div>
      <div class="col-md-6">
        <p>{{lang=="ru"?"Choose the exchange:":"Choose the exchange:"}}</p>
        <div class="row">
          <div class="col-md-6">
            <div class="form-check">
              <label class="form-check-label">
                <input type="radio" class="form-check-input" v-model='exchange' value ="0">
                  {{lang=="ru"?"FTX":"FTX"}}
              <i class="input-helper"></i></label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input type="radio" class="form-check-input" v-model='exchange' value ="1">
                {{lang=="ru"?"Binance":"Binance"}}
              <i class="input-helper"></i></label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-check">
              <label class="form-check-label">
                <input type="radio" class="form-check-input" v-model='exchange' value ="2">
                  {{lang=="ru"?"OKX":"OKX"}}
              <i class="input-helper"></i></label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input type="radio" class="form-check-input" v-model='exchange' value ="3">
                {{lang=="ru"?"KuCoin":"KuCoin"}}
              <i class="input-helper"></i></label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6" v-if="$parent.plan_status>1">
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox" :key="amount_key" class="form-check-input" @change='changeTypeOftradingAmount(), check_autotrading()' v-model='trading.enabled'>
              {{lang=="ru"?"Использовать автоторговлю ":"Use Auto-Trade"}}
          <i class="input-helper"></i></label>
        </div>
        <div class="form-group row">
          <label for="subscription_title" class="col-sm-12" >{{lang=="ru"?"Сумма к торговле (USDT)":"Amount to trade (USDT)"}}</label>
          <div class="col-sm-12">
            <input type="text" class="form-control" :disabled='trading.enabled?false:true' :class='trading.enabled && (isNaN(parseFloat(trading.amount)) || parseFloat(trading.amount) < 10) ? "border border-danger" : ""' id="subscription_title" v-model='trading.amount'>
          </div>
        </div>
        <p><span>{{lang=="ru"?"Если вы выберете этот тип торговли, то учавствовать в сделках будет только ":"If you choose this type of trading, then only the fixed "}}</span><span style="text-decoration:underline">{{lang=="ru"?"фиксированная ":"amount "}}</span><span>{{lang=="ru"?"часть вашего депозита в USDT":"of your free deposit in USDT will be traded"}}</span></p>
      </div>
      <div class="col-md-6">
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox" class="form-check-input"  :key="percent_key" v-model='trading.percent_usdt' @change='changeTypeOftradingPercent(), check_autotrading()' :disabled="$parent.plan_status<4">
              {{lang=="ru"?"Использовать автоторговлю ":"Use Auto-Trade"}}
          <i class="input-helper"></i></label>
        </div>
        <div class="form-group">
          <label for="trading_fee" class="col-sm-12">{{lang=="ru"?"Процент USDT ":"Percent of USDT"}}</label>
          <div class="col-sm-12">
            <div class="input-group">
              <input type="number" class="form-control" :disabled='trading.percent_usdt?false:true' :class='trading.percent_usd && (isNaN(parseFloat(percent_of_usdt))) ? "border border-danger" : ""' id="percent_usd" placeholder="0" step='0.025' v-model='percent_of_usdt'>
              <div class="input-group-append">
                <span class="input-group-text">%</span>
              </div>
            </div>
          </div>
        </div>
        <p><span>{{lang=="ru"?"Если вы выберете этот тип торговли, то учавствовать  в сделках будет только указанный ":"If you choose this type of trading, then only the fixed "}}</span><span style="text-decoration:underline">{{lang=="ru"?"процент ":"percentage "}}</span><span>{{lang=="ru"?"свободного депозита в USDT ":"of your free deposit in USDT will be traded"}}</span></p>
      </div>
    </div>
   <div style="border-top: 1px solid gray; margin-bottom:15px"></div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox" class="form-check-input" v-model='trading.auto_stop_loss' :disabled="$parent.plan_status<4">
              {{lang=="ru"?"стоп-лосс:":"stop-loss:"}}
          <i class="input-helper"></i></label>
        </div>
        <div class="form-group row">
          <div class="col-sm-12">
            <div class="input-group">
              <input type="number" class="form-control" id="stop_loss" v-on:input='checkStopLoss()' placeholder="0" step='0.5' max="-1" v-model='stop_loss_amount' :disabled="$parent.plan_status<4">
              <div class="input-group-append">
                <span class="input-group-text">%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox" class="form-check-input" v-model='trading.get_profit' :disabled="$parent.plan_status<4">
              {{lang=="ru"?"тейк-профит: ":"take profit: "}}
          <i class="input-helper"></i></label>
        </div>
        <div class="form-group row">
          <div class="col-sm-12">
            <div class="input-group">
              <input type="number" class="form-control"  placeholder="0" step='0.5'  v-model='get_profit_amount' :disabled="$parent.plan_status<4">
              <div class="input-group-append">
                <span class="input-group-text">%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox" class="form-check-input" v-model='trading.protective_profit' :disabled="$parent.plan_status<4">
              {{lang=="ru"?"Protective take profit: ":"Protective take profit: "}}
          <i class="input-helper"></i></label>
        </div>
        <div class="form-group row">
          <div class="col-sm-12">
            <div class="input-group">
              <input type="number" class="form-control"  placeholder="0" step='0.5'  v-model='protective_profit_amount' :disabled="$parent.plan_status<4">
              <div class="input-group-append">
                <span class="input-group-text">%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="border-top: 1px solid gray; margin-bottom:15px"></div>
    <div class="row">
      <div class="col-md-6">
        <h3>{{lang=="ru"?"Как вы желаете получать уведомления о сделках?":"How do you want to receive alerts about the trades?"}}</h3>
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox" class="form-check-input" v-model='alerts.email'>
              {{lang=="ru"?"почте":"Mail"}}
          <i class="input-helper"></i></label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox" class="form-check-input" v-model='alerts.telegram'>
            {{lang=="ru"?"Telegram":"Telegram"}}
          <i class="input-helper"></i></label>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox"  class="form-check-input"  v-model='trading.close_price' :disabled="$parent.plan_status<4">
              {{lang=="ru"?"Закрытие при цене:":"close the trade in price"}}
          <i class="input-helper"></i></label>
        </div>
        <div class="form-group row">
          <div class="col-sm-12">
            <input type="text" class="form-control" :disabled='(trading.close_price || $parent.plan_status>3)?false:true' :class='close_price && (isNaN(parseFloat(auto_close_price)) || parseFloat(auto_close_price) < 0) ? "border border-danger" : ""'  v-model='auto_close_price' >
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="form-group row">
      <label for="trading_fee" class="col-sm-12">{{lang=="ru"?"Комиссия за сделку":"Trading Fee"}}</label>
      <div class="col-sm-12">
        <div class="input-group">
          <input type="number" class="form-control" id="trading_fee" placeholder="0" step='0.025' v-model='tradingFee'>
          <div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
        </div>
      </div>
    </div> -->
    <template v-slot:modal-footer="{cancel}">
      <b-button @click='cancel()'>{{lang=="ru"?"Закрыть":"Close"}}</b-button>
      <b-button  v-if="$parent.plan_status>1 && editingSubscription" variant='primary' :disabled="save_flag?true:false"   @click="confirmSubscription()" v-html="editingSubscription ?(lang=='ru'?'Сохранить':'Save'):(lang=='ru'?'Подписатья':'Subscribe')"></b-button>
      <!-- <b-button variant='primary' @click='saveSubscription()' v-if='$parent.balance >= strategy.price'>{{lang=="ru"?"Подтвердить":"Confirm"}}</b-button> -->
    </template>
  </b-modal>
  <b-modal v-model="confirmBigSubscriptionCheckModal" content-class="property-modal">
    <template v-slot:modal-title>
      {{lang=="ru"?"Подтвердить подписку":"Confirm subscription"}}
    </template>
    <div style="text-align:center; margin-bottom:20px">Would you like to subscribe on it or make big subscription for 3 bots?</div>
    <div class="row">
      <!-- <div class="col-md-6">
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox" class="form-check-input" v-model='single_subscription' @change="checkKeys_2()">
              {{lang=="ru"?"Make subscription for current bot":"Make subscription for current bot"}}
          <i class="input-helper"></i></label>
        </div>
      </div> -->
      <div class="col-md-6">
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox" class="form-check-input" v-model='big_sub' @change="checkKeys_1()">
              {{lang=="ru"?"Make big subscription":"Make big subscription"}}
          <i class="input-helper"></i></label>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer="{cancel}">
      <b-button @click='cancel()'>{{lang=="ru"?"Закрыть":"Close"}}</b-button>
      <b-button  variant='primary'  @click="CheckBigSubscription()">OK</b-button>
    </template>
  </b-modal>
  <b-modal v-model="confirmOtherAssets">
    <template v-slot:modal-title>
      {{lang=="ru"?"Предупреждение":"Warning"}}
    </template>
    {{lang=="ru"?"Вы изменили таймфрейм/параметры/актив, помните, что это несёт дополнительные риски. Мы не рекомендуем использовать что-либо, кроме Биткоина или Эфира, если вы новичок.":"You have changed timeframes / values / assets, please remember that this carries additional risks. We don't recommend using anything other than Bitcoin or Ethereum if you are a beginner."}}
    <template v-slot:modal-footer="{cancel}">
      <b-button @click='cancel()'>{{lang=="ru"?"Закрыть":"Close"}}</b-button>
      <b-button variant='primary' @click='seachPair()'>{{lang=="ru"?"Понимаю":"Understand"}}</b-button>
    </template>
  </b-modal>
  <b-modal v-model="showDelayUnownedModal">
    <template v-slot:modal-title>
      {{lang=="ru"?"Предупреждение":"Warning"}}
    </template>
    {{lang=="ru"?"Данные будут отображаться с задержкой в одну неделю, пока вы не подпишетесь на эту стратегию.":"The data will be displayed with a delay of one week until you subscribe to this strategy."}}
    <template v-slot:modal-footer="{cancel}">
      <b-button @click='cancel()'>{{lang=="ru"?"Закрыть":"Close"}}</b-button>
    </template>
  </b-modal>
  <b-modal v-model="ResumeSubscriptionModal">
    <template v-slot:modal-title>
      {{lang=="ru"?"Предупреждение":"Warning"}}
    </template>
     {{lang=="ru"?"Вы хотите возобновить эту подписку?":"Do you want to resume this subscription?"}}
    <template v-slot:modal-footer="{cancel}">
      <b-button @click='cancel()'>{{lang=="ru"?"Закрыть":"Close"}}</b-button>
      <b-button variant='primary' @click='ResumeSubscription()'>{{lang=="ru"?"Понимаю":"Understand"}}</b-button>
    </template>
  </b-modal>
  <b-modal v-model="showDelayPausedModal">
    <template v-slot:modal-title>
      {{lang=="ru"?"Предупреждение":"Warning"}}
    </template>
     {{lang=="ru"?"Эта стратегия приостановлена, пока данные отображаются с задержкой в одну неделю.":"This strategy is paused for now the data is displayed with a delay of one week."}}
    <template v-slot:modal-footer="{cancel}">
      <b-button @click='cancel()'>{{lang=="ru"?"Закрыть":"Close"}}</b-button>
    </template>

  </b-modal>
  <b-modal v-model="showDescription">
    <template v-slot:modal-title>
      {{ lang == 'ru' ? 'Описание' : 'Description'}}
    </template>
    {{lang=="ru"? description_ru:description}}
    <br/>
    <a v-if="description_link" :href="description_link">{{description_link}}</a>
    <template v-slot:modal-footer="{cancel}">
      <b-button @click='cancel()'>{{lang=='ru'?'Закрыть':'Close'}}</b-button>
    </template>
  </b-modal>
  <b-modal v-model="confirmShort">
    <template v-slot:modal-title>
      Hello
    </template>
    <p style='text-align: center;'>
      {{lang=="ru"?"Пожалуйста, убедитесь, что у вас выставлено адекватное плечо к выбранному активу на Binance. Пример - 1x. Также рекомендуем проверить наличие галки для фьючерсов в настройках API":"Please make sure you have adequate leverage on the selected asset on Binance. Example - 1x. We also recommend checking the presence of a checkbox for futures in the API settings."}}
    </p>
    <template v-slot:modal-footer="{cancel}">
      <b-button @click="cancel()">{{lang=="ru"?"Хорошо":"OK"}}</b-button>
    </template>
  </b-modal>
</div>
</template>

<script>
// import { createChart } from 'lightweight-charts'
import BalanceChart from './BalanceChart'
import VueApexCharts from 'vue-apexcharts'
export default {
  components: { BalanceChart, apexchart: VueApexCharts },
  data () {
    return {
      is_only_alert: false,
      auto_close_price: 0,
      confirmShort: false,
      trading_fee: false,
      isBalanceMovement: true,
      selection_key: false,
      pctProfitables: 0,
      isOrderlist: false,
      isOrderlistMonthly: false,
      existOrder: false,
      amount_key: 0,
      percent_key: 0,
      isActive: true,
      isAnimation: true,
      isWord: true,
      description: '',
      description_ru: '',
      description_link: '',
      watermaker_1: 'Backtesting...',
      confirmSubscriptionModalShown: false,
      confirmOtherAssets: false,
      confirmAutoextendModalShown: false,
      backtestingNow: false,
      subplotAdded: false,
      openInputTab: 0,
      subscriptionTitle: '',
      supportedPairs: [],
      selectedPair: '',
      supportedTimeframes: [],
      selectedTimeframe: '',
      strategyInputs: [],
      chart: undefined,
      expire: null,
      barSeries: undefined,
      subscriptionPaused: false,
      current_buy_flag: false,
      current_sell_flag: false,
      plots: [],
      longProfit: 0,
      shortProfit: 0,
      bnhReturn: 0,
      strategy: {
        title: '',
        inputs: [],
        price: 0,
        hasShort: true
      },
      alerts: {
        telegram: true,
        email: true
      },
      trading: {
        enabled: false,
        amount: undefined,
        auto_stop_loss: false,
        percent_usdt: false,
        after_stop_loss: false,
        get_profit: false,
        close_price: false,
        protective_profit: false,
      },
      protective_profit_amount: 0,
      orders: [],
      MonthlyOrders: [],
      long_orders: [],
      query_orders: [],
      short_orders: [],
      backtestTimeout: undefined,
      lastCandleInterval: undefined,
      balanceMovement: [],
      tradingFee: 0,
      pyramiding: 0,
      percent_of_usdt: 0,
      auto_extend: false,
      time_during: 14,
      lang: 'en',
      stop_loss_amount: -10,
      get_profit_amount: 10,
      properties_text: 'Properties',
      inputs_text: 'Inputs',
      order_start_date: '',
      propertiesModal: false,
      save_flag: false,
      big_subscription: 1,
      confirmBigSubscriptionCheckModal: false,
      single_subscription: false,
      big_sub: false,
      ResumeSubscriptionModal: false,
      showDescription: false,
      first_backtest: 1,
      is_backtest: 1,
      exchange: 0
    }
  },
  props: {
    editingSubscription: {
      type: Boolean,
      default: false
    }
  },
  created (){
    this.check_bigsubscriptoin();
    this.get_by_sell_status();
    var re_this =this
    setTimeout(function(){
       re_this.is_only_alert = true; 
    }, 3000);
  },
  mounted () {
    this.lang = this.$cookie.get('lang');
    if (this.lang=="ru"){
      this.properties_text="Свойства";
      this.inputs_text="Значения";
    }
    this.expire=this.$route.query.expire;
    const chartElement = document.getElementById('chart')
    const chart = LightweightCharts.createChart(chartElement, {
      height: 550,
      width: chartElement.offsetWidth,
      layout: {
        backgroundColor: 'black',
        textColor: '#FFFFFF',
      },
      grid: {
        vertLines: {
          color: 'rgba(70, 130, 180, 0.5)',
          style: 1,
          visible: true
        },
        horzLines: {
          color: 'rgba(70, 130, 180, 0.5)',
          style: 1,
          visible: true
        }
      },
      timeScale: {
        timeVisible: true,
        secondsVisible: false
      },
      elements: {
        line: {borderWidth: 1}
      },
      // watermark: {
      //   color: 'rgba(100, 100, 100, 0.8)',
      //   visible: false,
      //   text: 'Backtesting...',
      //   fontSize: 50,
      //   horzAlign: 'center',
      //   vertAlign: 'center',
      // },
      crosshair: {
        mode: 0
      }
    })
    this.chart = chart
    this.barSeries = chart.addCandlestickSeries()
    this.axios.get('//data.tradingapp.pro/supportedAssets')
      .then((response) => {
        var supportedAssets = response.data
        this.supportedPairs = supportedAssets.pairs
        this.supportedTimeframes = supportedAssets.timeframes
      }).then(() => {
        if (this.editingSubscription) {
          this.axios.get('/subscription/show/' + this.$route.params.subscription_id, {withCredentials: true})
            .then(response => {
              var subscription = response.data.subscription
              this.axios.get('/strategy/' + subscription.strategy_id)
                .then((response) => {
                  var strategy = response.data
                  this.selectedPair = subscription.pair || this.supportedPairs[0]
                  this.selectedTimeframe = subscription.timeframe || 5
                  this.subscriptionTitle = subscription.name
                  this.subscriptionPaused = (subscription.status === 2)
                  this.alerts.telegram = subscription.telegram_alerts
                  this.alerts.email = subscription.email_alerts
                  this.trading.enabled = subscription.autotrade
                  this.trading.amount = subscription.autotrade_amount
                  this.trading.percent_usdt = subscription.percent_usdt
                  this.trading.auto_stop_loss = subscription.auto_stop_loss
                  this.trading.after_stop_loss = subscription.after_stop_loss
                  this.trading.get_profit = subscription.get_profit
                  this.stop_loss_amount = subscription.auto_stop_amount
                  this.trading.protective_profit = subscription.protective_profit
                  this.protective_profit_amount = subscription.protective_profit_amount
                  this.get_profit_amount = subscription.get_profit_amount
                  this.auto_extend = subscription.auto_extend
                  this.auto_close_price = subscription.auto_close_price
                  this.trading.close_price = subscription.close_price
                  this.percent_of_usdt = subscription.percent_usdt_amount
                  this.exchange = subscription.exchange
                  strategy.inputs.forEach((input) => {
                    if (subscription.inputs[input.id]) {
                      input.defval = subscription.inputs[input.id]
                      // console.log(input)
                    }
                  })
                  // console.log(strategy.inputs)
                  if (strategy.hasShort) {
                    this.confirmShort = true
                  }
                  this.strategy = strategy
                  this.description = strategy.description
                  this.description_ru = strategy.description_ru
                  this.description_link = strategy.description_link
                  var tags = strategy.tags.replaceAll(' ', '').split(',')
                  if (tags.includes('alltimeframe') === false) {
                    if (this.selectedTimeframe === '60') {
                      this.supportedTimeframes = ['30', '60']
                    } else if (this.selectedTimeframe === '240') {
                      this.supportedTimeframes = ['60', '240', '1440', '10080']
                    }
                  }
                  this.loadChartData()
                })
            })
        } else {
          this.axios.get('/strategy/' + this.$route.params.strategy_id)
            .then((response) => {
              var strategy = response.data
              // this.subscriptionTitle = strategy.title + ' ' + formatTimeframe()
              this.selectedPair = strategy.preferred_pair || this.supportedPairs[0]
              this.selectedTimeframe = strategy.preferred_timeframe || 5
              // if(strategy.preferred_timeframe==15||strategy.preferred_timeframe==30){
              //   this.time_during=7
              // }else{
              //   this.time_during=14
              // }
              this.description=strategy.description
              this.strategy = strategy
              var tags=strategy.tags.replaceAll(" ","").split(',');
              console.log(strategy.tags);
              console.log(tags);
              if(tags.includes("alltimeframe")==false){
                if(this.selectedTimeframe==="60"){
                  this.supportedTimeframes=["30", "60"]
                }else if(this.selectedTimeframe==="240"){
                  this.supportedTimeframes=["60", "240", "1440", "10080"]
                }
              }
              this.loadChartData()
            })
        }

        this.lastCandleInterval = setInterval(() => {
          if (this.editingSubscription && !this.subscriptionPaused) {
            this.axios.get('//data.tradingapp.pro/lastCandle', {params: {asset: this.selectedPair, tf: this.selectedTimeframe}})
              .then((candle) => {
                this.barSeries.update(candle.data)
              })
          }
        }, 5 * 1000)
      })

    var legend = document.createElement('div')
    legend.classList.add('legend')
    chartElement.appendChild(legend)

    var firstRow = document.createElement('div')
    firstRow.innerText = ''
    firstRow.style.color = 'white'
    legend.appendChild(firstRow)

    chart.subscribeCrosshairMove((param) => {
      if (param.time) {
        const price = param.seriesPrices.get(this.barSeries)
        firstRow.innerText = 'Open: ' + '  ' + price.open.toFixed(2)
      } else {
        // firstRow.innerText = 'ETC USD 7D VWAP';
      }
    })

    window.addEventListener('resize', function () {
      chart.resize(chartElement.offsetWidth, 550)
    })
  },
  methods: {
    get_by_sell_status(){
      this.axios.post('/subscription/current_buy_flag', {subscription_id: this.$route.params.subscription_id}, {withCredentials: true})
      .then(response => {
        if (response.data.success == false) {
          this.current_sell_flag = true;
        }
      })
    },
    get_slider(xaxis){
      var peorid_orders=[];
      for(var i=0; i<this.orders.length; i++){
        if(this.orders[i].entry_timestamp*1000>=xaxis.min && this.orders[i].entry_timestamp*1000 <=xaxis.max){
          peorid_orders.push(this.orders[i])
        }
      }
      var balance=0
      console.log(peorid_orders)
      peorid_orders.map(peorid_orders => {
        if(peorid_orders.profit){
          balance = (100 + balance) * (1 + peorid_orders.profit / 100) - 100
        }
        return balance.toFixed(2)
      })
      if(this.strategy.hasShort){
        this.short_orders=peorid_orders
      }else{
        this.query_orders=peorid_orders
      }
      console.log("==========query_orders==========")
      console.log(this.query_orders)
      this.longProfit=balance
      if(this.strategy.hasShort){
        this.shortProfit=balance
      }
      this.pctProfitables= (peorid_orders.filter((order) => { return order.profit > 0 }).length / peorid_orders.length) * 100
      return this.longProfit
    },
    description_show(){
      this.showDescription=true
    },
    changeOrderList(key){
      if(key == 'ba'){
        this.isBalanceMovement = true;
        this.isOrderlist = 0;
        this.isOrderlistMonthly = false;
      }else if(key == 'mo'){
        this.isBalanceMovement = false;
        this.isOrderlist = false;
        this.isOrderlistMonthly = true;
      }else{
        this.isBalanceMovement = false;
        this.isOrderlist = true;
        this.isOrderlistMonthly = false;
      }
    },
    format_datetime (timestamp) {
      var ts = new Date(timestamp * 1000)
      return ts.toLocaleString()
    },
    check_autotrading(){
      console.log("============subscriptions in backtesting===================")
      console.log(this.$parent.subscriptions)
      var total_count=0
      for(var i=0; i<this.$parent.subscriptions.length; i++){
        var subscription=this.$parent.subscriptions[i];
        if(subscription.autotrade || subscription.percent_usdt){
          total_count++
        }
      }
      console.log("===========total trading count=============")
      console.log(total_count)
      var user_status=this.$parent.plan_status
      if(this.trading.enabled || this.trading.percent_usdt){
        if(user_status==2){
          if(total_count>=1){
            this.$root.$bvToast.toast("You are using 1 auto-tradings already", {
                title: 'Notification',
                variant: 'warning',
                solid: true
            })
            this.trading.enabled=false
            this.trading.percent_usdt=false
            this.amount_key++
            this.percent_key++
          }
        }else if(user_status==3){
          if(total_count>=2){
            this.$root.$bvToast.toast("You are using 2 auto-tradings already", {
                title: 'Notification',
                variant: 'warning',
                solid: true
            })
            this.trading.enabled=false
            this.trading.percent_usdt=false
            this.amount_key++
            this.percent_key++
          }
        }else if(user_status==4){
          if(total_count>=3){
            this.$root.$bvToast.toast("You are using 3 auto-tradings already", {
                title: 'Notification',
                variant: 'warning',
                solid: true
            })
            this.trading.enabled=false
            this.trading.percent_usdt=false
            this.amount_key++
            this.percent_key++

          }
        }
      }
    },
    changeTypeOftradingAmount(){
        if(this.trading.enabled){
          this.trading.percent_usdt=false
        }

    },
    changeTypeOftradingPercent(){
        if(this.trading.percent_usdt){
          this.trading.enabled=false
        }
    },
    ResumeSubscription () {
      this.axios.get('/subscription/change_status/' + this.$route.params.subscription_id, {params: {status: 1, restart_state: null}, withCredentials: true})
        .then((response) => {
          if (response.data.success) {
            console.log(response)
            // this.$parent.refresh_user_info();
            window.location.reload()
          } else {
            if (response.data.error_message) {
              this.$root.$bvToast.toast(response.data.error_message, {
                title: 'Notification',
                variant: 'warning',
                solid: true
              })
            }
          }
        })
    },
    resumeSubscriptionModalShow(){
      this.ResumeSubscriptionModal=true
    },
    checkKeys_1(){
        this.single_subscription=false
    },
    checkKeys_2(){
        this.big_sub=false
    },
    CheckBigSubscription(){
      if(this.single_subscription){
        this.confirmSubscription()
      }else if(this.big_sub){
        this.$router.push('/dashboard/market?big_bot_id='+ this.$route.params.strategy_id)
      }
    },
    confirmBigSubscriptionCheck(){
      this.confirmBigSubscriptionCheckModal=true
    },
    check_bigsubscriptoin(){
      this.axios.get('/subscription/check_bigsubscription', {
          withCredentials: true
        })
        .then((response) => {
            if (response.data.success) {
              this.big_subscription=0;
            }
        })
    },
    checkStopLoss(){
      if(this.stop_loss_amount>0){
          this.save_flag=true
          this.$root.$bvToast.toast(this.lang=='ru'?'Значение стопа должно содержать минус!':'The stop value must contain a minus!', {
          title: this.lang=='ru'?'Уведомление ':'Notification',
          variant: 'warning',
          solid: true
        })
      }else{
        this.save_flag=false
      }
    },
    openPropertiesModal(){
      this.propertiesModal=true
    },
    loadChartData () {
      this.axios.get('//data.tradingapp.pro/getData', {params: {asset: this.selectedPair, tf: this.selectedTimeframe}})
        .then((candles) => {
          console.log(candles)
          var data = ((this.editingSubscription && !this.subscriptionPaused) ? candles.data : candles.data.filter(candle => ((candle.time + this.time_during * 24 * 60 * 60) * 1000) <= Date.now()))
          this.order_start_date=data[data.length-1].time
          this.bnhReturn = (data[0].open / data[data.length - 1].close) - 1
          this.barSeries.setData(data)
        })
    },
    setPair (pair) {
      this.selectedPair = pair
      this.loadChartData()
      this.runBacktest()
    },
    runEnter () {
      this.runBacktest()
    },
    seachPair () {
      this.confirmOtherAssets=false
      if (this.editingSubscription) {
        this.saveSubscription()
      } else {
        this.$parent.refresh_user_info()
        this.confirmSubscriptionModalShown = true
      }
    },
    calculate_fee(){
      if(this.trading_fee){
        this.tradingFee = 0.075;
      }else{
        this.tradingFee = 0;
      }
    },
    setTimeframe (tf) {
      this.selectedTimeframe = tf
      this.loadChartData()
      this.runBacktest()
    },
    formatTimeframe (tf) {
      var intTF = parseInt(tf)
      if (intTF < 60) return tf + 'm'
      if (intTF < 1440) return (intTF / 60).toString() + 'h'
      if (intTF < 10080) return (intTF / 1440).toString() + 'D'
      if (intTF < 43200) return (intTF / 10080).toString() + 'W'
    },
    runBacktest (value) {
      this.backtestingNow = true
      this.isAnimation=true
      this.isActive=true
      this.watermaker_1="Backtesting..."
      if(value && value == 'fee1'){
      this.plots.forEach((plot) => {
        this.chart.removeSeries(plot)
      })
      this.plots = []
      var vm=this
      this.axios.post('//data.tradingapp.pro/first_backtest', {
        file: this.strategy.filename,
        pair: this.selectedPair,
        timeframe: this.selectedTimeframe,
        inputs: this.strategy.inputs
      }).then((response) => {
        var orders = response.data.orders
        // this.existOrder=true
        console.log("===========orders================");
        console.log(orders)
        var chartMarkers = []
        this.short_orders = []
        var short_orders_1 = []
        this.long_orders_1 = ((this.editingSubscription && !this.subscriptionPaused) ? orders : orders.filter((order) => { return ((order.entry_timestamp + this.time_during * 24 * 60 * 60) * 1000) <= Date.now() }))
        if (this.strategy.hasShort) {
          this.shortProfit = 0
          // this.short_orders=this.long_orders
          for (var i = 0; i < this.long_orders_1.length; i++) {
            var profit =this.long_orders_1[i+1]?(( this.long_orders_1[i].exit_price /this.long_orders_1[i+1].entry_price - 1) * 100):0
            if(this.long_orders_1[i].exit_price){
              short_orders_1.push({
                entry_timestamp: this.long_orders_1[i].exit_timestamp,
                entry_price: this.long_orders_1[i].exit_price,
                exit_timestamp: this.long_orders_1[i+1]?this.long_orders_1[i+1].entry_timestamp:null,
                exit_price: this.long_orders_1[i+1]?this.long_orders_1[i+1].entry_price:null,
                profit: profit
              })
            }
            this.shortProfit += profit
          }
          console.log("=======changed short order===========")
          console.log(short_orders_1)
        }
        console.log("======== first short order==========")
        console.log(short_orders_1)
        var orders_1 = [];
        if(this.strategy.hasShort){
          orders_1 = short_orders_1.sort((first, second) => {
          if (first.entry_timestamp > second.entry_timestamp) {
              return 1;
            } else if (first.entry_timestamp < second.entry_timestamp) {
              return -1;
            }
            return 0;
          })
        }else{
          orders_1 = this.long_orders_1.sort((first, second) => {
          if (first.entry_timestamp > second.entry_timestamp) {
              return 1;
            } else if (first.entry_timestamp < second.entry_timestamp) {
              return -1;
            }
            return 0;
          })
        }
        orders_1.map((order) => {
          if (order.entry_timestamp) {
            chartMarkers.push({
              time: order.entry_timestamp,
              position:this.strategy.hasShort?'aboveBar':'belowBar',
              color: this.strategy.hasShort?'purple':'blue',
              shape:this.strategy.hasShort?'arrowDown':'arrowUp',
              size: 2
            })
          }
          if (order.exit_timestamp && ((this.editingSubscription && !this.subscriptionPaused) || (order.exit_timestamp + 7 * 24 * 60 * 60) * 1000) <= Date.now()) {
            chartMarkers.push({
              time: order.exit_timestamp,
              position:this.strategy.hasShort?'belowBar':'aboveBar',
              color:this.strategy.hasShort?'blue':'purple',
              shape:this.strategy.hasShort?'arrowUp':'arrowDown',
              size: 2
            })
          }
          if(this.strategy.hasShort==0){
            order.profit = ((order.exit_price / order.entry_price - 1) * 100 - this.tradingFee * 2) || 0
          }else{
            order.profit = ((order.entry_price / order.exit_price - 1) * 100 - this.tradingFee * 2) || 0
          }
        })
        this.barSeries.setMarkers(chartMarkers)
        // Map short orders for profit

        // this.pctProfitables= (this.long_orders.filter((order) => { return order.profit > 0 }).length / orders.length) * 100
        // var balance = 0
        // this.balanceMovement = this.orders.map(order => {
        //   if(order.profit){
        //     balance = (100 + balance) * (1 + order.profit / 100) - 100
        //   }
        //   return balance.toFixed(2)
        // })
        // this.longProfit = balance
        // if(this.strategy.hasShort){
        //   this.shortProfit=balance
        // }
        var plots = response.data.plots
        if (plots[0]) {
          Object.keys(plots[0]).forEach((key) => {
            if (key === 'time') { return }
            var currentPlot = []
            console.log(plots[0])
            plots.forEach((plotElement) => {
              if ((!this.editingSubscription || this.subscriptionPaused) && ((plotElement.time + this.time_during * 24 * 60 * 60) * 1000) >= Date.now()) return
              currentPlot.push({time: plotElement.time, value: plotElement[key]})
            })
            var lineParams = {lineWidth: 1, color: response.data.plot_styles[key].color, crosshairMarkerVisible: false}
            if (!response.data.plot_styles[key].overlay && !this.subplotAdded) {
              this.chart.applyOptions({
                priceScale: {
                  scaleMargins: {
                    top: 0.1,
                    bottom: 0.02
                  }
                }
              })
              this.chart.addSubPane()
              this.subplotAdded = true
            }
            // console.log(lineParams)
            var lineSeries = this.chart.addLineSeries(lineParams, response.data.plot_styles[key].overlay ? 0 : 1)
            lineSeries.setData(currentPlot)
            this.plots.push(lineSeries)
          })

        }
        // this.backtestingNow = false
        this.isActive=false;
        this.selection_key=true
        // this.chart.applyOptions({watermark: {visible: false}})
      })
      }
      this.axios.post('//data.tradingapp.pro/backtest', {
        file: this.strategy.filename,
        pair: this.selectedPair,
        timeframe: this.selectedTimeframe,
        inputs: this.strategy.inputs
      }).then((response) => {
        this.plots.forEach((plot) => {
          this.chart.removeSeries(plot)
        })
        this.plots = []
        var orders = response.data.orders
        this.existOrder=true
        console.log("===========orders================");
        console.log(orders)
        var chartMarkers = []

        this.short_orders = []
        this.long_orders = ((this.editingSubscription && !this.subscriptionPaused) ? orders : orders.filter((order) => { return ((order.entry_timestamp + this.time_during * 24 * 60 * 60) * 1000) <= Date.now() }))

        if (this.strategy.hasShort) {
          this.shortProfit = 0
          // this.short_orders=this.long_orders
          for (var i = 0; i < this.long_orders.length; i++) {
            var profit =this.long_orders[i+1]?(( this.long_orders[i].exit_price /this.long_orders[i+1].entry_price - 1) * 100):0
            if(this.long_orders[i].exit_price){
              this.short_orders.push({
                entry_timestamp: this.long_orders[i].exit_timestamp,
                entry_price: this.long_orders[i].exit_price,
                exit_timestamp: this.long_orders[i+1]?this.long_orders[i+1].entry_timestamp:null,
                exit_price: this.long_orders[i+1]?this.long_orders[i+1].entry_price:null,
                profit: profit
              })
            }
            this.shortProfit += profit
          }
          console.log(this.short_orders)
        }
        console.log("========short order==========")
        console.log(this.short_orders)
        if(this.strategy.hasShort){
          this.orders = this.short_orders.sort((first, second) => {
          if (first.entry_timestamp > second.entry_timestamp) {
              return 1;
            } else if (first.entry_timestamp < second.entry_timestamp) {
              return -1;
            }
            return 0;
          })
        }else{
          this.orders = this.long_orders.sort((first, second) => {
          if (first.entry_timestamp > second.entry_timestamp) {
              return 1;
            } else if (first.entry_timestamp < second.entry_timestamp) {
              return -1;
            }
            return 0;
          })
        }
        console.log("==========this.order======")
        console.log(this.orders)
        if(this.orders[this.orders.length-1].exit_price == undefined){
            console.log(this.orders[this.orders.length-1].exit_price)
            if (this.editingSubscription) {
              var entry_time=this.orders[this.orders.length-1].entry_timestamp
              this.axios.post('/subscription/current_buy_flag', {subscription_id: this.$route.params.subscription_id, entry_time: entry_time}, {withCredentials: true})
                .then(response => {
                    if (response.data.success) {
                      this.current_buy_flag = true;
                    }
                })
            }
          }
        var monthData=[];
        for(var i=0; i<this.orders.length; i++){
          var order = this.orders[i];
          var date = this.$moment(order.exit_timestamp*1000).format('YYYY-MM')
          if(this.strategy.hasShort){
            var date_json = {'date': date, 'profit': order.exit_price? (order.entry_price - order.exit_price)/order.exit_price * 100:0}
          }else{
            var date_json = {'date': date, 'profit': order.exit_price? (order.exit_price - order.entry_price)/order.entry_price * 100:0}
          }
          monthData.push(date_json);
        }

        var groups = monthData.reduce(function (r, o) {
            var m = o.date;
            (r[m])? r[m].data.push(o.profit) : r[m] = {date: m , data: [o.profit]};
            return r;
        }, {});
        this.MonthlyOrders = Object.keys(groups).map(function(k){ return groups[k]; });
        console.log("===========month data=========")
        console.log(this.MonthlyOrders)

        this.query_orders=this.orders
        this.orders.map((order) => {
          if (order.entry_timestamp) {
            chartMarkers.push({
              time: order.entry_timestamp,
              position:this.strategy.hasShort?'aboveBar':'belowBar',
              color: this.strategy.hasShort?'purple':'blue',
              shape:this.strategy.hasShort?'arrowDown':'arrowUp',
              size: 2
            })
          }
          if (order.exit_timestamp && ((this.editingSubscription && !this.subscriptionPaused) || (order.exit_timestamp + 7 * 24 * 60 * 60) * 1000) <= Date.now()) {
            chartMarkers.push({
              time: order.exit_timestamp,
              position:this.strategy.hasShort?'belowBar':'aboveBar',
              color:this.strategy.hasShort?'blue':'purple',
              shape:this.strategy.hasShort?'arrowUp':'arrowDown',
              size: 2
            })
          }
          if(this.strategy.hasShort==0){
            order.profit = ((order.exit_price / order.entry_price - 1) * 100 - this.tradingFee * 2) || 0
          }else{
            order.profit = ((order.entry_price / order.exit_price - 1) * 100 - this.tradingFee * 2) || 0
          }
        })

        this.barSeries.setMarkers(chartMarkers)

        // Map short orders for profit
        this.pctProfitables= (this.long_orders.filter((order) => { return order.profit > 0 }).length / orders.length) * 100
        var balance = 0
        this.balanceMovement = this.orders.map(order => {
          if(order.profit){
            balance = (100 + balance) * (1 + order.profit / 100) - 100
          }
          return balance.toFixed(2)
        })

        this.longProfit = balance
        if(this.strategy.hasShort){
          this.shortProfit=balance
        }
        var plots = response.data.plots
        if (plots[0]) {
          Object.keys(plots[0]).forEach((key) => {
            if (key === 'time') { return }
            var currentPlot = []
            console.log(plots[0])
            plots.forEach((plotElement) => {
              if ((!this.editingSubscription || this.subscriptionPaused) && ((plotElement.time + this.time_during * 24 * 60 * 60) * 1000) >= Date.now()) return
              currentPlot.push({time: plotElement.time, value: plotElement[key]})
            })
            var lineParams = {lineWidth: 1, color: response.data.plot_styles[key].color, crosshairMarkerVisible: false}
            if (!response.data.plot_styles[key].overlay && !this.subplotAdded) {
              this.chart.applyOptions({
                priceScale: {
                  scaleMargins: {
                    top: 0.1,
                    bottom: 0.02
                  }
                }
              })
              this.chart.addSubPane()
              this.subplotAdded = true
            }
            // console.log(lineParams)
            var lineSeries = this.chart.addLineSeries(lineParams, response.data.plot_styles[key].overlay ? 0 : 1)
            lineSeries.setData(currentPlot)
            this.plots.push(lineSeries)
          })
        }
        this.backtestingNow = false
        this.isActive=false;
        this.selection_key=true
        var buy_key;
        // this.chart.applyOptions({watermark: {visible: false}})
      }).catch(function (error) {
        console.log(error);
        vm.watermaker_1="Backtest stopped";
        vm.isAnimation=false;
        vm.$root.$bvToast.toast('The script with the given values cannot be backtested!', {
          title: 'Notification',
          variant: 'warning',
          solid: true
        })
      })
    },
    // grossProfit (orders) {
    //   return orders.reduce((accumulator, current) => {
    //     return current.profit > 0 ? accumulator + parseFloat(current.profit) : accumulator
    //   }, /* initial value */ 0)
    // },
    // grossLoss (orders) {
    //   return orders.reduce((accumulator, current) => {
    //     return current.profit < 0 ? accumulator + parseFloat(current.profit) : accumulator
    //   }, /* initial value */ 0)
    // },
    orderMovementData(){
      var dates=this.orders.map(order => {return (order.entry_timestamp * 1000)})
      var profits= this.balanceMovement
      var datas=[]
      for(var i=0; i<dates.length; i++){
        var data=[dates[i], profits[i]]
        datas.push(data)
      }
      var serial=[
        {
          name:'Profit',
          data:datas
        }
      ]
      return serial
    },
    balanceMovementData () {
      var data = {
        labels: this.orders.map(order => {
          return (new Date(order.entry_timestamp * 1000)).toLocaleString()
        }),
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: this.balanceMovement
          }
        ]
      }
      console.log("=============order data=====")
      console.log(data)
      return data
    },
    // bnhReturn () {
    //   console.log(this.barSeries)
    // },
    pctProfitable (orders) {
      return (orders.filter((order) => { return order.profit > 0 }).length / orders.length) * 100
    },
    avgTrade (filter, orders) {
      var filteredOrders = orders.filter((order) => {
        if (filter > 0) {
          return order.profit > 0
        } else if (filter < 0) {
          return order.profit < 0
        } else return true
      })
      if (filteredOrders.length === 0) { return 0 }
      // console.log(filteredOrders)
      return filteredOrders.reduce((acc, curr) => acc + curr.profit, 0) / filteredOrders.length
    },
    avgBarInTrade (filter, orders) {
      var filteredOrders = orders.filter((order) => {
        if (filter > 0) {
          return order.profit > 0
        } else if (filter < 0) {
          return order.profit < 0
        } else return true
      })
      if (filteredOrders.length === 0) { return 0 }
      return Math.round(filteredOrders.reduce((acc, curr) => acc + (parseInt(curr.exit_timestamp) - parseInt(curr.entry_timestamp)) / (parseInt(this.selectedTimeframe) * 60), 0) / filteredOrders.length)
    },
    confirmSubscription () {
      if(this.trading.enabled === true || this.trading.percent_usdt){
        if ((this.exchange == 1 && this.$parent.binance_keys === false) || (this.exchange == 0 && this.$parent.FTX_keys === false)) {
          this.$root.$bvToast.toast(this.lang=='ru'?'Сначала подключите свои ключи API':'Please connect your API keys firstly!', {
              title: this.lang === 'ru' ? 'Уведомление' : 'Notification',
              variant: 'warning',
              solid: true
          })
          return false
        }
      }
      if (this.subscriptionTitle.length === 0) {
        this.subscriptionTitle = this.strategy.title + ' ' + this.formatTimeframe(this.selectedTimeframe)
      }
      console.log(this.selectedPair);
      if(this.selectedPair =="BINANCE:BTCUSDT" || this.selectedPair =="BINANCE:ETHUSDT"){
        if (this.editingSubscription) {
          this.saveSubscription()
        } else {
          this.$parent.refresh_user_info()
          this.confirmSubscriptionModalShown = true
        }
      }else{
        this.confirmOtherAssets=true
      }
    },
    make_trading(){
      if(this.trading.enabled || this.trading.percent_usdt){
        var entry_time=this.long_orders[this.long_orders.length-1].entry_timestamp
        this.axios.post('/subscription/make_trading', {
        subscription_id: this.$route.params.subscription_id,
        direct_flag: this.current_buy_flag,
        entry_timestamp:entry_time,
        hasShort: this.strategy.hasShort
        }, {withCredentials: true}).then(response => {
          if (response.data.success) {
            this.current_buy_flag=!this.current_buy_flag
            this.get_by_sell_status();
            this.$root.$bvToast.toast('You have successfully connected to the current trade', {
                title: 'Notification',
                variant: 'success',
                solid: true
              })
          }
        })
      }else{
        this.$root.$bvToast.toast('please insert the trading amount in properties', {
            title: 'Notification',
            variant: 'warning',
            solid: true
        })
        return false
      }

    },
    
    only_alert() {
      var total_count=0
      for(var i=0; i<this.$parent.subscriptions.length; i++){
        var subscription=this.$parent.subscriptions[i];
        if(subscription.autotrade || subscription.percent_usdt){
          total_count++
        }
      }
      var user_status=this.$parent.plan_status
        if(user_status==2){
          if(total_count>=1){
            this.$root.$bvToast.toast("You are using 1 auto-tradings already", {
                title: 'Notification',
                variant: 'warning',
                solid: true
            })
            return false;
          }
        }else if(user_status==3){
          if(total_count>=2){
            this.$root.$bvToast.toast("You are using 2 auto-tradings already", {
                title: 'Notification',
                variant: 'warning',
                solid: true
            })
            return false;
          }
        }else if(user_status==4){
          if(total_count>=3){
            this.$root.$bvToast.toast("You are using 3 auto-tradings already", {
                title: 'Notification',
                variant: 'warning',
                solid: true
            })
            return false;
          }
        }
        this.axios.post('/subscription/only_alert', {
          subscription_id: this.$route.params.subscription_id
        }, {withCredentials: true}).then(response => {
          console.log(response)
          if (response.data.success) {
            this.$parent.refresh_user_info()
            // this.$router.push('/dashboard/overview')
            this.$root.$bvToast.toast('Saved successfully', {
              title: 'Notification',
              variant: 'success',
              solid: true
            })
            this.trading.enabled = true
          }
        })
    },
    
    saveSubscription () {
      if (this.editingSubscription) {
        this.axios.post('/subscription/update', {
          subscription_id: this.$route.params.subscription_id,
          name: this.subscriptionTitle,
          pair: this.selectedPair,
          timeframe: this.selectedTimeframe,
          inputs: this.strategy.inputs || {},
          sendTelegram: this.alerts.telegram,
          sendEmail: this.alerts.email,
          autotrade: this.trading.enabled,
          autotrade_amount: this.trading.amount,
          auto_extend: this.auto_extend,
          stop_loss_amount:this.stop_loss_amount,
          auto_stop_loss: this.trading.auto_stop_loss,
          get_profit: this.trading.get_profit,
          protective_profit: this.trading.protective_profit,
          get_profit_amount: this.get_profit_amount,
          after_stop_loss: this.trading.after_stop_loss,
          percent_usdt: this.trading.percent_usdt,
          percent_of_usdt: this.percent_of_usdt,
          auto_close_price: this.auto_close_price,
          close_price: this.trading.close_price,
          protective_profit_amount: this.protective_profit_amount,
          exchange: this.exchange
        }, {withCredentials: true}).then(response => {
          console.log(response)
          if (response.data.success) {
            this.$parent.refresh_user_info()
            // this.$router.push('/dashboard/overview')
            this.$root.$bvToast.toast('Saved successfully', {
              title: 'Notification',
              variant: 'success',
              solid: true
            })
          }
        })
      } else {
        this.axios.post('/strategy/subscribe', {
          strategy_id: this.$route.params.strategy_id,
          name: this.subscriptionTitle,
          pair: this.selectedPair,
          timeframe: this.selectedTimeframe,
          inputs: this.strategy.inputs || {},
          subscriptionTitle: this.subscriptionTitle,
          sendTelegram: this.alerts.telegram,
          sendEmail: this.alerts.email,
          autotrade: this.trading.enabled,
          autotrade_amount: this.trading.amount,
          auto_extend: this.auto_extend,
          stop_loss_amount:this.stop_loss_amount,
          auto_stop_loss:this.trading.auto_stop_loss,
          after_stop_loss:this.trading.after_stop_loss,
          percent_usdt:this.trading.percent_usdt,
          percent_of_usdt:this.percent_of_usdt,
          get_profit:this.trading.get_profit,
          get_profit_amount: this.get_profit_amount,
          auto_close_price: this.auto_close_price,
          close_price: this.trading.close_price
        }, {withCredentials: true}).then(response => {
          // console.log(response)
          if (response.data.success) {
            this.$parent.refresh_user_info()
            this.$router.push('/dashboard/overview')
            this.$root.$bvToast.toast('Subscribed successfully', {
              title: 'Notification',
              variant: 'success',
              solid: true
            })
          }
        })
      }
    },
    scrollToBottom () {
      window.scrollTo(0, document.body.scrollHeight)
    }
  },
  computed: {
    showDelayUnownedModal () {
      return !this.editingSubscription
    },
    showDelayPausedModal () {
      return this.editingSubscription && this.subscriptionPaused
    },
    chartOptions: function() {
      return {
          chart: {
            events: {
              selection: (chartContext, { xaxis, yaxis })=> {
                console.log("=========selection=========")
                console.log(xaxis)
                if(this.selection_key){
                  return this.get_slider(xaxis)
                }else{
                  return false
                }
              }
            },
            id: 'area-datetime',
            type: 'area',
            height: 425,
            // zoom: {
            //   autoScaleYaxis: true
            // },
            toolbar: {
              autoSelected: 'selection',
              show: true
            },
            // brush: {
            //   enabled: true,
            //   target: 'chartyear'
            // },
            selection: {
              enabled: true,
              xaxis: {
                min: undefined,
                max: undefined
                // min: new Date('01 Jan 2021').getTime(),
                // max: new Date('01 May 2021').getTime()
              },
              fill: {
                color: '#24292e',
                opacity: 0.2
              },
              stroke: {
                width: 2,
                dashArray: 3,
                color: '#ccc',
                opacity: 1
              }
            },
            foreColor: "#ccc"
          },
          stroke: {
            width: 3
          },
          dataLabels: {
            enabled: false
          },
          grid: {
            borderColor: "#555",
            clipMarkers: false,
            yaxis: {
              lines: {
                show: false
              }
            }
          },
          markers: {
            size: 2,
            colors: ["#000524"],
            strokeColor: "#00BAEC",
            strokeWidth: 2
          },
          xaxis: {
            type: 'datetime',
            color: "#fff"
          },
          yaxis: {
            tickAmount: 16,
            color: "#fff"
          },
          tooltip: {
            x: {
              format: 'dd MMM yyyy HH:mm'
            },
            theme: "dark"
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 100]
            }
          },
      }
    }
  },
  watch: {
    strategy: {
      handler () {        
        clearTimeout(this.backtestTimeout)
        if(this.first_backtest == 1){
          this.backtestTimeout = setTimeout(this.runBacktest('fee1'), 1500)
          this.first_backtest = 2
        }
      },
      deep: true
    },
    tradingFee: {
      handler () {
        clearTimeout(this.backtestTimeout)
        this.backtestTimeout = setTimeout(this.runBacktest, 500)
      }
    }
  },
  beforeRouteLeave (before, to, next) {
    clearInterval(this.lastCandleInterval)
    next()
  }
}
</script>

<style lang="css">
.legend {
  position: absolute;
  top: 7px;
  left: 7px;
  z-index: 2;
}

.tab-content {
  height: 380px;
  overflow-y: scroll;
}
.tabs>div>ul{
  display: none !important;
}
.nav-tabs{
  display: none !important;
}
.dropdown-menu {
  max-height: 250px;
  /* overflow-y: scroll; */
}

.preference-tab {
  /* height */
}

.alert-danger {
  color: #ff9999;
}

.alert-danger a {
  color: #75b7fd;
}
.header-title{
  text-align: center;
}
.alert i {
  font-size: inherit;
}
a.dropdown-item:hover {
  color: #0056b3 !important;
}
.water-mark {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
}
.water-letter{
    font-size: 50px;
    color:rgba(100, 100, 100, 0.8);
    text-align: center;
}
.watermaker{
    animation: animate
    1.5s linear infinite;
    z-index: 9999;
}
.property-modal>.modal-header{
  padding: 10px 26px !important;
}

.button-group > button {
  margin-top: 10px;
}

@media (min-width: 576px){
  .modal-dialog {
      max-width: 600px !important;
      margin: 30px auto;
  }
  .button-group{
    text-align: right
  }

  .backtest-button {
    display: none;
  }
}

@keyframes animate {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 0.7;
    }
    100% {
        opacity: 0;
    }
}
.form-control:disabled{
  background: #6c757d !important;
}
.td-element{
  text-align: center;
}
.grid-margin-1{
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Backtester.vue